import React from "react";
import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import moment from "moment";
import { CmpDatePicker } from "../../../Component/Common/ToolBox/ToolBox";
import SearchIcon from "@mui/icons-material/Search";
const HeaderComponent = ({
  truck,
  handleAddNew = () => {},
  status,
  handleLoadBtn = () => {},
  filterState,
  setFilterState,
  handleChange,
  vRdxDBLocation = [],
  ftruckIdScan,
  headErrors
}) => {
  const isMobile = useMediaQuery("(max-width:650px)");
  const isTabOrDesktop = !isMobile;

  const handleStatusChange = (event) => {
    setFilterState((prev) => ({
      ...prev,
      status: event.target.value,
    }));
  };


  return (
    <div className="stock-detail">
      <Grid
        container
        columnSpacing={{ xs: 1, sm: 1.5, md: 2, lg: 4 }}
        rowSpacing={{ xs: 1.5, sm: 1, md: 2, lg: 2 }}
        marginTop={{ xs: 0.5, sm: 0.5, md: 1, lg: 1 }}
      >
        <Grid item xs={6} sm={3} md={1.7}>
          <Typography>From Date</Typography>
          <CmpDatePicker
            xValue={filterState.dateFrom}
            xOnChange={(newValue) =>
              setFilterState((obj) => ({
                ...obj,
                dateFrom: newValue.$d,
              }))
            }
            xName={"dateFrom"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item xs={6} sm={3} md={1.7}>
          <Typography>To Date</Typography>
          <CmpDatePicker
            style={{ width: "100% !important" }}
            xValue={filterState.dateTo}
            xOnChange={(newValue) =>
              setFilterState((obj) => ({
                ...obj,
                dateTo: newValue.$d,
              }))
            }
            xName={"dateTo"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2.5}>
          <Typography>Location</Typography>

          <Autocomplete
            freeSolo
            id="free-solo-2-demo"
            disableClearable
            options={vRdxDBLocation} // Use full objects
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.Name1
            } // Support free text input
            value={
              vRdxDBLocation.find((loc) => loc.UID === filterState.location) ||
              null
            }
            onChange={(event, newValue) => {
              if (typeof newValue === "string") {
                setFilterState((prev) => ({
                  ...prev,
                  location: newValue, // Store typed value
                }));
              } else if (newValue) {
                setFilterState((prev) => ({
                  ...prev,
                  location: newValue.Uid, // Store UID when selecting from dropdown
                }));
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                slotProps={{
                  input: {
                    ...params.InputProps,
                    type: "search",
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={1.5}>
          <Typography>Status</Typography>
          <FormControl fullWidth>
            <Select
            
              value={filterState?.status}
              name="status"
              onChange={handleStatusChange}
            >
              {status.map((sts) => (
                <MenuItem key={sts} value={sts}>
                  {sts}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={2.5}>
        <Typography>Truck Id</Typography>
        <TextField
            value={filterState?.truckId.Name1}
            fullWidth
            id="truckId"
            name="truckId"
             onChange={handleChange}
            onKeyDown={ftruckIdScan}
            autoComplete="off"
            error={headErrors?.truckId === "" ? false : true}
            helperText={headErrors?.truckId}
            sx={{
              "& .MuiOutlinedInput-root": {
                paddingRight: "0px !important",
              },
              "& .MuiInputBase-input": {
                padding: "5.5px 0px 5.5px 10px !important",
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={ftruckIdScan}
                    sx={{
                      "& .MuiButtonBase-root": {
                        padding: "0px !important",
                      },
                    }}
                  >
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {/* <Typography> Truck ID</Typography>
          <FormControl fullWidth>
            <Select
              value={filterState?.truckId}
              name="truckId"
              onChange={handleChange}
            >
              {truck.map((trck) => (
                <MenuItem key={trck.UId} value={trck.UId}>
                  {trck.Name1}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
        </Grid>

        <Grid
          item
          xs={12}
          sm={4}
          md={2}
          display={isMobile ? "" : "flex"}
          justifyContent={isMobile ? "center" : "flex-end"}
          textAlign={isMobile ? "center" : "flex-end"}
          gap={2}
        >
          <Button
            variant="contained"
            sx={{
              width: isMobile ? "80px" : "100px",
              mt: isMobile ? 1 : 2,
              textTransform: "capitalize",
            }}
            onClick={handleLoadBtn}
          >
            Load
          </Button>
          {isTabOrDesktop && (
            <Button
              variant="contained"
              sx={{
                width: "100px",
                mt: isMobile ? "0px !important" : 2,
                textTransform: "capitalize",
              }}
              onClick={handleAddNew}
            >
              New
            </Button>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default HeaderComponent;
